export const mutationKeys = {
  // Accounts
  createAccount: 'createAccount',
  updateAccount: 'updateAccount',

  // Events
  createEvent: 'createEvent',
  updateEvent: 'updateEvent',

  // Tasks
  createTask: 'createTask',
  updateTask: 'updateTask',

  // Contacts
  createContact: 'createContact',
  updateContact: 'updateContact',

  // Employees
  createEmployee: 'createEmployee',
  updateEmployee: 'updateEmployee',

  // Task Templates
  createTaskTemplate: 'createTaskTemplate',
  updateTaskTemplate: 'updateTaskTemplate',

  // Event Templates
  createEventTemplate: 'createEventTemplate',
  updateEventTemplate: 'updateEventTemplate',

  // Email Templates
  createEmailTemplate: 'createEmailTemplate',
  updateEmailTemplate: 'updateEmailTemplate',
  sendEmails: 'sendEmails',

  // User Permissions
  createUserRole: 'createUserRole',
  updateUserRole: 'updateUserRole',

  // Organization
  updateOrganization: 'updateOrganization',
};
